import withRoles from '../../../hoc/withRoles';
import EnrollDropdown from './EnrollDropdown';

export default withRoles(EnrollDropdown);
